type BadgeVariant = "brand" | "success" | "danger";

type Props = {
    children: React.ReactNode;
    variant?: BadgeVariant;
};

const VARIANT: Record<BadgeVariant, string> = {
    brand: "bg-brand-light text-brand-dark",
    success: "bg-success/15 text-success",
    danger: "bg-danger/15 text-danger",
};

export function Badge({ children, variant = "brand" }: Props) {
    return (
        <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${VARIANT[variant]}`}
        >
            {children}
        </span>
    );
}
